import React from 'react';
import { Stack, Typography, List } from '@mui/material';
import PageContainer from 'pages/PageContainer';
import { CommunityGuidelinesLists } from 'shared/constants/legal-pages-constants/community-guidelines-constants';
import { HomeLink } from 'components/LegalPagesLinks/HomeLink';
import { MailToLink } from 'components/LegalPagesLinks/MailToLink';
import { CustomListItem } from 'components/List/CustomListItem/CustomListItem';

const CommunityGuidelines: React.FunctionComponent = () => (
  <PageContainer showMenu={false}>
    <Stack py={{ xs: 0, md: 4 }} rowGap="64px" width="100%" maxWidth="1200px" mx="auto">
      <Typography variant="h1">Community Guidelines</Typography>
      <Stack rowGap="16px">
        <Typography variant="body2">
          <HomeLink />
          {` is a platform for structured debates and respectful discussion. 
          These guidelines exist to keep the community safe, fair, and productive. By using `}
          <HomeLink />
          {`,
          you agree to follow these rules in addition to our Terms & Conditions.`}
        </Typography>
      </Stack>

      <Stack rowGap="24px">
        <Typography variant="h2" className="legal-page-title">
          1. Respectful Conduct
        </Typography>
        <List className="list-legal-pages">
          {CommunityGuidelinesLists.RespectfulConduct.map((item, index) => (
            <CustomListItem key={index} {...item} />
          ))}
        </List>
      </Stack>

      <Stack rowGap="24px">
        <Typography variant="h2" className="legal-page-title">
          2. Content Standards
        </Typography>
        <List className="list-legal-pages">
          {CommunityGuidelinesLists.ContentStandards.map((item, index) => (
            <CustomListItem key={index} {...item} />
          ))}
        </List>
      </Stack>

      <Stack rowGap="24px">
        <Typography variant="h2" className="legal-page-title">
          3. Debate Etiquette
        </Typography>
        <List className="list-legal-pages">
          {CommunityGuidelinesLists.DebateEtiquette.map((item, index) => (
            <CustomListItem key={index} {...item} />
          ))}
        </List>
      </Stack>

      <Stack rowGap="24px">
        <Typography variant="h2" className="legal-page-title">
          4. Platform Integrity
        </Typography>
        <List className="list-legal-pages">
          {CommunityGuidelinesLists.PlatformIntegrity.map((item, index) => (
            <CustomListItem key={index} {...item} />
          ))}
        </List>
      </Stack>

      <Stack rowGap="24px">
        <Typography variant="h2" className="legal-page-title">
          5. Enforcement
        </Typography>
        <List className="list-legal-pages">
          {CommunityGuidelinesLists.Enforcement.map((item, index) => (
            <CustomListItem key={index} {...item} />
          ))}
        </List>
      </Stack>

      <Stack rowGap="24px">
        <Typography variant="h2" className="legal-page-title">
          6. Reporting Issues
        </Typography>
        <Typography variant="body2">
          {`If you see behavior or content that violates these guidelines, please report it to our
          support team at `}
          <MailToLink />
        </Typography>
      </Stack>

      <Stack rowGap="24px">
        <Typography variant="h2" className="legal-page-title">
          7. Changes to Guidelines
        </Typography>
        <Typography variant="body2">
          {'We may update these guidelines from time to time. Continued use of '}
          <HomeLink />
          {' means you agree to the latest version.'}
        </Typography>
      </Stack>
    </Stack>
  </PageContainer>
);

export default CommunityGuidelines;
